// Action SuperAdmin : liste des produits canoniques de TOUS les comptes.
//
// L'appel passe par le relais Express /stocks/superadmin/products, jamais
// directement par le storehouse : le relais transmet l'identité de
// l'utilisateur connecté, et le storehouse vérifie lui-même auprès de
// domainModel que cet utilisateur est SuperAdmin.

// Messages de repli, employés quand le serveur ne fournit pas le sien. Les
// deux refus attendus : 401 pour un jeton invalide ou expiré, 403 pour un
// utilisateur qui n'est pas SuperAdmin.
const DEFAULT_MESSAGES = {
    401: "Session expirée ou invalide : merci de vous reconnecter.",
    403: "Accès refusé : cet écran est réservé aux SuperAdmin.",
}

function errorMessage(status, body) {
    if (body && body.error && body.error.message) {
        return body.error.message
    }
    if (DEFAULT_MESSAGES[status]) {
        return DEFAULT_MESSAGES[status]
    }
    return "Impossible de charger les produits (erreur " + status + ")."
}

/**
 * Charge les produits canoniques tous comptes confondus.
 * @param {boolean} includeStock demande les quantites en stock (couteux cote
 *        storehouse) : jamais actif au premier rendu.
 */
export function fetchSuperAdminProducts(includeStock = false) {
    return async function (dispatch) {
        dispatch({
            type: "FETCH_SUPERADMIN_PRODUCTS_START",
            payload: ""
        })

        try {
            const url = includeStock
                ? '/stocks/superadmin/products?include_stock=true'
                : '/stocks/superadmin/products'

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            })

            // Le 403 sans corps (utilisateur non authentifie) n'est pas du JSON.
            let body = {}
            try {
                body = await response.json()
            } catch (parseError) {
                body = {}
            }

            if (!response.ok || (body && body.error)) {
                dispatch({
                    type: "FETCH_SUPERADMIN_PRODUCTS_ERROR",
                    payload: errorMessage(response.status, body),
                })
                return
            }

            dispatch({
                type: "FETCH_SUPERADMIN_PRODUCTS_FULFILLED",
                payload: {
                    produits: Array.isArray(body.produits) ? body.produits : [],
                    totaux: body.totaux || {},
                    withStock: includeStock,
                },
            })

        } catch (err) {
            console.log("[ERROR] fetchSuperAdminProducts ", err)
            dispatch({
                type: "FETCH_SUPERADMIN_PRODUCTS_ERROR",
                payload: "Impossible de joindre le serveur.",
            })
        }
    }
}
